import * as React from 'react';

import { translate } from 'components/translate-hoc';
import { TEXT_KEYS } from './invitee.constants';
import arrowDown from '../../../assets/arrow-down.svg';
import { IInviteeProps, IInviteeStateProps } from './invitee.types';
import './invitee.styles.less';
import { formatUnit } from '../../units-formatter';

export class Invitee extends React.Component<IInviteeProps, IInviteeStateProps> {
    public state: IInviteeStateProps = {
        open: false,
        isLoading: true
    };

    public async componentDidMount() {
        const { playerInfo, updateInvitationInfo } = this.props;
        await updateInvitationInfo({
            referrerUbiAccountId: playerInfo.referrerUbiAccountId!,
            platformId: playerInfo.platformId!
        });
        this.setState({ isLoading: false });
    }

    public handleDropDownState = (): void => {
        this.setState(prevState => ({ open: !prevState.open }));
    };
    public renderRewardImage(): JSX.Element | null {
        const { inviteeRewardImageSrc } = this.props;
        return (
            <div className="sitegen-friend-referral-dashboard-page-invitee__reward__image">
                <img src={inviteeRewardImageSrc} alt=""/>
            </div>
        );
    }
    public render(): JSX.Element | null {
        const { open, isLoading } = this.state;
        const {
            dangerouslyTranslateWithHTML: translateKey,
            paramValue: statValue,
            paramThreshold,
            statsFormatting,
            invitationInfo,
            inviteeRewardImageSrc
        } = this.props;

        if (isLoading) {
            return null;
        }

        const formattedParamTreshold = formatUnit(paramThreshold, statsFormatting);
        const formattedStatValue = formatUnit(statValue, statsFormatting);
        const status = translateKey(TEXT_KEYS.STATUS, {
            statValue: formattedStatValue,
            paramThreshold: formattedParamTreshold,
            username: invitationInfo.username
        });
        const rewardDescription = translateKey(TEXT_KEYS.REWARD_DESCRIPTION);

        return (
            <div className="sitegen-friend-referral-dashboard-page-invitee">
                <div className={`sitegen-friend-referral-dashboard-page-invitee__wrapper ${open && 'open'}`}>
                    <div className="sitegen-friend-referral-dashboard-page-invitee__container">
                        <div className="sitegen-friend-referral-dashboard-page-invitee__status">
                            {status}
                        </div>
                        <img src={arrowDown} alt="" onClick={this.handleDropDownState} />
                    </div>
                    {open ? (
                        <div className="sitegen-friend-referral-dashboard-page-invitee__reward">
                            {inviteeRewardImageSrc ? this.renderRewardImage() : null}
                            <div className="sitegen-friend-referral-dashboard-page-invitee__reward__description">
                                {rewardDescription}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default translate()(Invitee);
